/*
 *
 * Home constants
 *
 */

export const SET_SHOW_POPUP = 'app/components/PopupContainer/SET_SHOW_POPUP';
